<template>
  <div class="castle">
    <h1>戦型・戦法・囲い等タグ</h1>

    <h2>現行のタグ定義リスト</h2>
    <CastleList />
  </div>
</template>

<style lang="scss">
.castle {
  margin: 0 1vw;
  img {
    max-width: 100%;
  }
}
</style>

<script lang="ts">
import { defineComponent, SetupContext, reactive } from "vue";
import CastleList from "@/components/CastleList.vue";

export default defineComponent({
  props: {},
  setup(props, ctx: SetupContext) {
    const data = reactive({});
    return {
      props,
      data,
      ctx,
    };
  },
  components: {
    CastleList,
  },
});
</script>
